import React from "react";
import { ErrorTemplate } from "components/ErrorTemplate";
import { ContentError as ContentErrorData } from "helpers/Consts";
import { useTitleChange } from "hooks/useTitleChange";
export const ContentError = () => {
  useTitleChange();
  return <ErrorTemplate {...ContentErrorData} />;
};
